import BirthdayCalendarOptionState from './schema/BirthdayCalendarOptionState';
import { createStore } from 'satcheljs';
import '../mutators/discardBirthdayCalendarOption';
import '../mutators/updateBirthdayCalendarCurrentState';
import '../mutators/updateBirthdayCalendarInitialState';

/**
 * Creates store which reflects the current state of settings under birthday calendar option
 */
export default createStore<BirthdayCalendarOptionState>('birthdayCalendarOption', {
    birthdayCalendarEnabledInitial: null,
    birthdayCalendarEnabledCurrent: null,
});
